import { Link } from '@micro-frontend-react/employee-experience/lib/Link';
import { Label } from 'office-ui-fabric-react';
import * as React from 'react';
import * as WindowSize from '../../redux/hooks/useWindowDimensions';
import * as styled from './Footer.styled';

export function Footer(): React.ReactElement {
  const year = new Date().getFullYear();
  const { width, height } = WindowSize.useWindowDimensions();

  return (
    <styled.FooterRoot>
      <styled.Container>
        <styled.FooterMenus>
          <styled.FooterMenuItem windowWidth={width} windowHeight={height}>
            <Link
              to="http://go.microsoft.com/fwlink/?LinkId=518021"
              title=""
              target="_blank"
              usageEvent={{
                feature: 'EVL',
                subFeature: 'Home.Footer.DataPrivacyLink',
              }}
            >
              Microsoft data privacy notice
            </Link>
          </styled.FooterMenuItem>
          <styled.FooterMenuItem windowWidth={width} windowHeight={height}>
            <Link
              to="https://microsoft.sharepoint.com/sites/hrweb/sitePages/Legal-Notice.aspx"
              title=""
              target="_blank"
              usageEvent={{
                feature: 'EVL',
                subFeature: 'Home.Footer.LegalNoticeLink',
              }}
            >
              Legal notice
            </Link>
          </styled.FooterMenuItem>
          <styled.FooterMenuItem
            arie-aria-roledescription={`${year} Microsoft`}
            windowWidth={width}
            windowHeight={height}
            tabIndex={0}
            style={{ marginLeft: 'auto' }}
          >
            <Label style={{ fontWeight: 400 }}>&copy; {year} Microsoft</Label>
          </styled.FooterMenuItem>
        </styled.FooterMenus>
      </styled.Container>
    </styled.FooterRoot>
  );
}
